import type {
  PlatformerJumpConfig,
  PlatformerJumpInstance,
  PlatformerJumpSubmission,
} from "../../puzzles/core/platformerJump";
import type {
  TrigCannonConfig,
  TrigCannonInstance,
  TrigCannonSubmission,
} from "../../puzzles/core/trigCannon";
import type {
  VectorDroneConfig,
  VectorDroneInstance,
  VectorDroneSubmission,
} from "../../puzzles/core/vectorDrone";
import type { Quest } from "../../types/domain";
import type { PuzzleInstance } from "../../puzzles/core/framework";
import type { SpecPuzzleTemplateId } from "../../puzzles/core/specTemplates";
import { GenericPuzzlePlayer } from "./GenericPuzzlePlayer";
import { PlatformerJumpPlayer } from "./PlatformerJumpPlayer";
import { TrigCannonPlayer } from "./TrigCannonPlayer";
import { VectorDronePlayer } from "./VectorDronePlayer";

export function PuzzlePlayer({
  quest,
  instance,
  onLock,
}: {
  quest: Quest;
  instance: unknown;
  onLock(submission: Record<string, unknown>): void;
}) {
  if (quest.templateId === "vector-drone") {
    return (
      <VectorDronePlayer
        config={quest.config as VectorDroneConfig}
        instance={instance as VectorDroneInstance}
        onLock={(submission: VectorDroneSubmission) => onLock(submission)}
      />
    );
  }
  if (quest.templateId === "trig-cannon") {
    return (
      <TrigCannonPlayer
        config={quest.config as TrigCannonConfig}
        instance={instance as TrigCannonInstance}
        onLock={(submission: TrigCannonSubmission) => onLock(submission)}
      />
    );
  }
  if (quest.templateId === "platformer-jump") {
    return (
      <PlatformerJumpPlayer
        config={quest.config as PlatformerJumpConfig}
        instance={instance as PlatformerJumpInstance}
        onLock={(submission: PlatformerJumpSubmission) => onLock(submission)}
      />
    );
  }
  const visualConfig =
    quest.config &&
    typeof quest.config === "object" &&
    "visualConfig" in quest.config &&
    quest.config.visualConfig &&
    typeof quest.config.visualConfig === "object"
      ? (quest.config.visualConfig as Record<string, unknown>)
      : undefined;
  return (
    <GenericPuzzlePlayer
      templateId={quest.templateId as SpecPuzzleTemplateId}
      instance={instance as PuzzleInstance}
      visualConfig={visualConfig}
      onLock={(submission) => onLock(submission)}
    />
  );
}
